import React from 'react';

export default () => {
  return (
    <>
      Mon&#8211;Fri, <time dateTime='7:00-06:00'>7am</time>&#8211;<time dateTime='18:00-06:00'>6pm</time> CT
    </>
  );
};
